import { getTrackingIdRecord, TrackingIdRecords, TrackingIdRecordsMetaDataName, trackingIdRecordsServiceId } from './ga4-tracking/tracking-id-records';
import { getLatestServicesConsent } from '../custom-consent';

//UTMZ Cookie Data Extraction
const gaCookieParser = rawCookie => {
  let cookieData = {};
  if (rawCookie.startsWith('__utmz')) {
    cookieData = {
      utmz: {
        utmcsr: '',
        utmccn: '',
        utmcmd: '',
        utmctr: '',
        utmcct: ''
      }
    };
  }
  if (rawCookie.startsWith('__utmi')) {
    cookieData = {
      utmi: {
        utmcsr: '',
        utmccn: '',
        utmcmd: '',
        utmctr: '',
        utmcct: ''
      }
    };
  }
  if (rawCookie) {
    rawCookie.replace(/(?:^| |;)__(utm[^;$]*)/g, (_, tagMatch) => {
      const type = tagMatch.slice(0, 4);
      const contentStr = tagMatch.slice(5);
      const cookieDataObject = cookieData[type];
      if (!cookieDataObject) {
        return;
      }

      if (type === 'utmz' || type === 'utmi') {
        const utmzParams = contentStr.slice(contentStr.indexOf('utm'));
        if (utmzParams) {
          utmzParams.split('|').forEach(parameter => {
            const keyValue = parameter.split('=');
            if (keyValue.length >= 2) {
              try {
                cookieDataObject[keyValue[0]] = global.unescape(/^\(.*\)$/.test(keyValue[1]) ? keyValue[1].replace(/^\(?(.*?)\)?$/, '$1') : keyValue[1]);
              } catch (e) {
                cookieDataObject[keyValue[0]] = keyValue[1];
              }
            }
          });
        }
      }
    });
  }
  return cookieData;
};

const readCookie = cookieName => {
  const cookieData = document.cookie.match('(^|; )' + cookieName + '=([^;]*)') || 0;
  if (cookieData.length >= 3) {
    return cookieData[2];
  }
};

const readCookieAsync = async cookieName => {
  if ('cookieStore' in window) {
    const cookie = await cookieStore.get(cookieName);
    return cookie && cookie.value ? cookie.value : undefined;
  }
  return readCookie(cookieName);
};
/**
 * Function for attaching tracking data to a payload.
 * Attaches utm parameters, google analytics client id and tippgeber id to the payload.
 * @param {object} payload object to be modified
 */
const attachTrackingPayload = async payload => {
  const utmzValue = await readCookieAsync('__utmz');
  const utmiValue = await readCookieAsync('__utmi');
  if (utmzValue || utmiValue) {
    const uzCook = '__utmz=' + (utmzValue || '');
    const uiCook = '__utmi=' + (utmiValue || '');
    window.utmz = gaCookieParser(uzCook);
    window.utmi = gaCookieParser(uiCook);
    payload.utm_parameters = {
      first_campaign: window.utmi.utmi.utmccn || '',
      first_content: window.utmi.utmi.utmcct || '',
      first_medium: window.utmi.utmi.utmcmd || '',
      first_source: window.utmi.utmi.utmcsr || '',
      first_term: window.utmi.utmi.utmctr || '',
      last_campaign: window.utmz.utmz.utmccn || '',
      last_content: window.utmz.utmz.utmcct || '',
      last_medium: window.utmz.utmz.utmcmd || '',
      last_source: window.utmz.utmz.utmcsr || '',
      last_term: window.utmz.utmz.utmctr || ''
    };
  }

  const metadata = {
    origin: 'website'
  };

  const gaValue = await readCookieAsync('_ga');
  if (gaValue) {
    metadata.google_analytics_client_id = gaValue;
  }

  const tippgeberValue = await readCookieAsync('tippgeber');
  if (tippgeberValue || window.localStorage?.getItem('tippgeber')) {
    metadata.tippgeber_id = tippgeberValue || window.localStorage?.getItem('tippgeber');
  }

  if (window.localStorage?.getItem('partner')) {
    metadata.partner_id = window.localStorage?.getItem('partner');
  }

  const trackingIdObj = {};

  Object.values(TrackingIdRecords).forEach(id => {
    const value = getTrackingIdRecord(id);
    if (value) {
      trackingIdObj[id] = value;
    }
  });

  if (Object.keys(trackingIdObj).length) {
    let trackingIdConsents;
    if (window.location.href.indexOf('ottonova.de') < 0 && window.location.href.indexOf('loaduc=1') < 0 && sessionStorage.getItem('loaduc') !== 'true') {
      trackingIdConsents = {};
      Object.values(trackingIdRecordsServiceId).forEach(id => {
        if (!trackingIdConsents[id]) {
          trackingIdConsents[id] = true;
        }
      });
    } else {
      trackingIdConsents = await getLatestServicesConsent(Object.values(trackingIdRecordsServiceId));
    }

    Object.keys(TrackingIdRecordsMetaDataName).forEach(id => {
      if (trackingIdConsents[trackingIdRecordsServiceId[id]]) {
        metadata[TrackingIdRecordsMetaDataName[id]] = trackingIdObj[id];
      }
    });
  }
  payload.metadata = metadata;
};
export default attachTrackingPayload;
